import { Button } from '@/components/ui/button'

export default function BotCreatePage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Create Agent Bot</h1>
      <p className="text-gray-500">Bot creation wizard - coming soon</p>
      <Button variant="outline" className="mt-4">
        Start Creation
      </Button>
    </div>
  )
}
